/* @flow weak */
import BoxBody from 'components/BoxBody.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Dialog from 'components/Dialog.jsx';
import DialogButton from 'components/DialogButton.jsx';
import Field from 'components/Field.jsx';
import FormNote from 'components/FormNote.jsx';
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Subscriber from 'entities/Subscriber';

const ChangeUntrustedNameModal = React.createClass({
  propTypes: {
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
    onCancel: React.PropTypes.func,
  },

  getInitialState() {
    return {
      subscriber: this.props.subscriber,
      firstName: this.props.subscriber.getFirstName(),
      lastName: this.props.subscriber.getLastName(),
    };
  },

  cancelConfirmDialog(event) {
    event.preventDefault();
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.onRequestHide();
  },

  // change
  changeName() {
    const subscriberId = this.props.subscriber.id;
    const { firstName, lastName } = this.state;
    RelationshipActions.updateName(subscriberId, firstName, lastName);
    this.props.onRequestHide();
  },

  closeUntrustedNameModal() {
    this.props.onRequestHide();
  },

  renderConfirmDialog() {
    const confirmString = 'Are you sure you want to change this participant’s name to '
      + this.state.firstName + ' ' + this.state.lastName + '?';
    return (
      <ConfirmDialog
        eventScreenName="ChangeUntrustedNameModal"
        title={confirmString}
        onConfirm={this.changeName}>
        A participant’s name can only be changed once.
      </ConfirmDialog>
    );
  },

  handleFirstNameChange(event) {
    this.setState({ firstName: event.target.value });
  },

  handleLastNameChange(event) {
    this.setState({ lastName: event.target.value });
  },

  render() {
    const confirmDialog = this.renderConfirmDialog();

    return (
      <Dialog
        {...this.props}
        className="ChangeUntrustedNameModal"
        title="Change name"
        size="xsmall"
        onRequestHide={this.closeUntrustedNameModal}>
        <BoxBody>
          <form>
            <Field>
              <Label>First name</Label>
              <Input
                value={this.state.firstName}
                onChange={this.handleFirstNameChange}
              />
            </Field>
            <Field>
              <Label>Last name</Label>
              <Input
                value={this.state.lastName}
                onChange={this.handleLastNameChange}
              />
            </Field>
            <FormNote glyph="caution" glyphColor="lava">
              You can only change this once.
            </FormNote>
            <ModalTrigger modal={confirmDialog}>
              <DialogButton>Change</DialogButton>
            </ModalTrigger>
          </form>
        </BoxBody>
      </Dialog>
    );
  },
});

export default ChangeUntrustedNameModal;



// WEBPACK FOOTER //
// ./src/chat/components/ChangeUntrustedNameModal.jsx